import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Moment from "moment";
import useRequest from "../../hooks/useRequest";
import Pagination from "../Pagination/Pagination";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Table from "../Table/Table";
import { SearchInput2, SearchSubmitButton } from "../Form/Form";
import { addOneToDate, downloadExcel } from "../../util/fn";
import { ArrowDown, ArrowUp } from "../../util/Svg";
import moment from "moment";

const OBJ_TABLE = {
    "Club Name": "clubName",
    amount: "amount",
    "Created At": "createdAt",
    status: "status",
};


const searchQueryHandler = (
    page,
    per_page,
    sortBy,
    order,
    clubName = "",
    dateFrom = "1970-01-01",
    dateTo
) => {
    if (sortBy.length > 0) {
        if (sortBy === "Created At") {
            sortBy = "createdAt";
        } else if (sortBy == "Club Name") {
            sortBy = "clubName";
        }
    } else {
        sortBy = "createdAt";
    }

    order = order.length > 0 ? order : "desc";

    dateFrom = dateFrom.length > 0 ? dateFrom : "1970-01-01";

    dateTo = dateTo ? addOneToDate(new Date(dateTo)) : addOneToDate(new Date());

    return `transactions/all?page=${page}&per_page=${per_page}&sortBy=${sortBy}&order=${order}&clubName=${clubName}&dateFrom=${dateFrom}&dateTo=${dateTo}`;
};

const ViewAll = () => {
    const [transactions, setTransactions] = useState([]);
    const [page, setPage] = useState(1);
    const [totalDocuments, setTotalDocuments] = useState(10);
    const [perPage, setPerPage] = useState(0);
    const [currentSort, setCurrentSort] = useState({
        sortBy: "createdAt",
        order: "desc",
    });

    const [isSearchToggleOpen, setIsSearchToggleOpen] = useState(false);
    const { request: requestExport, response: responseExport } = useRequest();

    const handleToggle = () => {
        const collapseElement = document.getElementById('collapseOne6');
        if (collapseElement) {
            collapseElement.classList.toggle('show');
        }
        setIsSearchToggleOpen(!isSearchToggleOpen);
    };

    const MySwal = withReactContent(Swal);

    const { records_per_page } = useSelector((state) => state.setting);

    const {
        register,
        handleSubmit,
        formState: { errors },
        resetField,
        getValues,
        clearErrors,
        setError,
        setValue,
        control
    } = useForm();

    const { request, response } = useRequest();


    useEffect(() => {
        if (records_per_page) {
            setPerPage(records_per_page);
            request(
                "GET",
                searchQueryHandler(
                    1,
                    records_per_page,
                    currentSort.sortBy,
                    currentSort.order
                )
            );
        }
        document.title = "Transactions- Calevalab";
    }, [records_per_page]);

    useEffect(() => {
        if (response) {
            setTransactions(response.transactions);
            setTotalDocuments((prev) =>
                response.totalDocuments !== undefined && response.totalDocuments !== null ? response.totalDocuments : prev
            );
        }
    }, [response]);


    const [searchObj, setSearchObj] = useState({
        clubName: "",
        dateFrom: "",
        dateTo: ""
    });

    const [isDisableSearch, setIsDisableSearch] = useState(true)

    const handleSearchObj = (name, value) => {
        if (name == 'dateTo') {
            if (new Date(value).getTime() > new Date().getTime()) {
                setError("dateTo", { type: "manual", message: "manual" })
                return;
            }
            clearErrors(name);
        }
        if (name == 'dateFrom') {
            if (new Date(value).getTime() > new Date().getTime()) {
                setError("dateFrom", { type: "manual", message: "manual" })
                return;
            }
            clearErrors(name);
        }

        let search = searchObj;
        search[name] = value;

        setSearchObj(search);

        if (search?.dateFrom && search?.dateTo) {
            if (Moment(search?.dateFrom).isAfter(search?.dateTo) && !Moment(search?.dateFrom).isSame(search?.dateTo, 'day')) {
                setError("dateTo", {
                    type: "manual_other",
                    message: "To Date cannot be smaller than From Date",
                });
                return;
            }
        }
        if (search?.clubName || search?.dateFrom || search?.dateTo) {
            setIsDisableSearch(false);
        } else {
            setIsDisableSearch(true);
        }
    }



    const fetchMoreData = ({ selected }) => {
        setTransactions([]);
        const { clubName, planName, dateFrom, dateTo } =
            getValues();

        setPage(selected + 1);
        request(
            "GET",
            searchQueryHandler(
                selected + 1,
                perPage,
                currentSort.sortBy,
                currentSort.order,
                clubName,
                dateFrom,
                dateTo
            )
        );
    };


    const onSearchHandler = (data) => {
        const { clubName, dateFrom, dateTo } =
            getValues();
        let error = 0;
        if (dateFrom && dateTo) {
            if (Moment(dateFrom).isAfter(dateTo) && !Moment(dateFrom).isSame(dateTo, 'day')) {
                setError("dateTo", {
                    type: "manual_other",
                    message: "To Date cannot be smaller than From Date",
                });
                error = 1;
            }
        }
        if (new Date(dateTo).getTime() > new Date().getTime()) {
            setError("dateTo", { type: "manual", message: "manual" })
            error = 1;
        }
        if (new Date(dateFrom).getTime() > new Date().getTime()) {
            setError("dateFrom", { type: "manual" })
            error = 1;
        }
        if (error == 1) {
            return;
        }

        request(
            "GET",
            searchQueryHandler(
                1,
                perPage,
                currentSort.sortBy,
                currentSort.order,
                clubName,
                dateFrom,
                dateTo
            )
        );
        setPage(1);
    };

    const onResetHandler = (e) => {
        e.preventDefault();
        resetField("clubName");
        resetField("dateFrom");
        resetField("dateTo");
        setIsDisableSearch(true);
        request(
            "GET",
            searchQueryHandler(1, perPage, currentSort.sortBy, currentSort.order)
        );
        setPage(1);
    };

    const perPageChangeHandler = (event) => {
        const { clubName, dateFrom, dateTo } =
            getValues();

        request(
            "GET",
            searchQueryHandler(
                1,
                event.target.value,
                currentSort.sortBy,
                currentSort.order,
                clubName,
                dateFrom,
                dateTo
            )
        );
        setPage(1);

        setPerPage(event.target.value);
    };

    const sortingHandler = (sortBy) => {
        const { clubName, dateFrom, dateTo } =
            getValues();

        if (currentSort.sortBy == sortBy) {
            const newOrder = currentSort.order === "asc" ? "desc" : "asc";
            request(
                "GET",
                searchQueryHandler(
                    page,
                    perPage,
                    sortBy,
                    newOrder,
                    clubName,
                    dateFrom,
                    dateTo
                )
            );
            setCurrentSort({ sortBy, order: newOrder });
        } else {
            request(
                "GET",
                searchQueryHandler(
                    page,
                    perPage,
                    sortBy,
                    "desc",
                    clubName,
                    dateFrom,
                    dateTo
                )
            );
            setCurrentSort({ sortBy, order: "desc" });
        }
    };


    const InputFields = [
        {
            label: "Club Name",
            name: "clubName",
            required: false,
        },
        {
            label: "Date From",
            name: "dateFrom",
            isDate: true,
            clearErrors,
            otherRegisterFields: {
                manual: true,
                feedback: "From Date cannot be greater than Current Date",
            },
        },
        {
            label: "Date To",
            name: "dateTo",
            isDate: true,
            clearErrors,
            otherRegisterFields: {
                manual: true,
                feedback: "To Date cannot be greater than Current Date",
            },
        },
    ];

    const downloadExcelHandler = () => {
        let newObjective = [
            {
                "Club Name": "",
                "Amount": "",
                "Created At": "",
                "Status": ""
            },
        ];

        if (transactions && transactions.length > 0) {
            newObjective = transactions.map((txn) => ({
                "Club Name": txn?.clubName || "",
                "Amount": txn?.amount && txn?.currencyCode
                    ? `${txn.amount} ${txn.currencyCode}`
                    : txn?.amount || "",
                "Created At": txn?.createdAt
                    ? moment(txn.createdAt).format("YYYY-MM-DD HH:mm")
                    : "",
                "Status": txn?.status || "",
            }));
        }

        downloadExcel(newObjective, "Transactions");
    };



    return (
        <div
            className="content  d-flex flex-column flex-column-fluid"
            id="kt_content"
        >
            <Breadcrumb
                title="Transactions"
                links={[{ to: "/", name: "Dashboard" }]}
            />

            <div className="d-flex flex-column-fluid">
                <div className=" container ">
                    <div className="row">
                        <div className="col-12">
                            <div className="card card-custom card-stretch card-shadowless">
                                <div className="card-header">
                                    <div className="card-title"></div>
                                    <div className="card-toolbar">
                                        <div className="">
                                            <button className="btn btn-primary mr-2 w125" type="button" aria-expanded="false" onClick={() => downloadExcelHandler()}>
                                                Export
                                            </button>
                                        </div>
                                        <a
                                            /*href="#!"*/
                                            className="btn btn-primary dropdown-toggle mr-2"
                                            onClick={handleToggle}
                                        >
                                            Search {isSearchToggleOpen ? <ArrowUp /> : <ArrowDown />}
                                        </a>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div
                                        className="accordion accordion-solid accordion-toggle-plus"
                                        id="accordionExample6"
                                    >
                                        <div
                                            id="collapseOne6"
                                            className="collapse"
                                            data-parent="#accordionExample6"
                                        >
                                            <div>
                                                <form
                                                    onSubmit={handleSubmit(onSearchHandler)}
                                                    className="kt-form kt-form--fit mb-0"
                                                >
                                                    <div className="row mb-6">
                                                        {InputFields.map((inputMain, index) => (
                                                            <SearchInput2
                                                                key={index}
                                                                {...inputMain}
                                                                errors={errors}
                                                                register={register}
                                                                setValue={setValue}
                                                                handleSearchObj={handleSearchObj}
                                                            />
                                                        ))}
                                                    </div>

                                                    <SearchSubmitButton
                                                        handleSubmit={handleSubmit}
                                                        onSearchHandler={onSearchHandler}
                                                        onResetHandler={onResetHandler}
                                                        isDisableSearch={isDisableSearch}
                                                    />
                                                </form>
                                                <hr />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="dataTables_wrapper faq-table">
                                        <Table
                                            currentSort={currentSort}
                                            sortingHandler={sortingHandler}
                                            mainData={transactions}
                                            tableHeading={Object.keys(OBJ_TABLE)}
                                            tableData={Object.values(OBJ_TABLE)}
                                            //   links={[
                                            //     {
                                            //       isLink: false,
                                            //       name: "Deactivate",
                                            //       click: changeStatusHandler,
                                            //       title: "Click To Activate",
                                            //     },
                                            //     {
                                            //       isLink: false,
                                            //       name: "Activate",
                                            //       click: changeStatusHandler,
                                            //       title: "Click To Deactivate",
                                            //     },
                                            //     {
                                            //       isLink: true,
                                            //       to: "/subscription/edit",
                                            //       name: "Edit",
                                            //       extraData: true,
                                            //     },
                                            //     { isLink: false, name: "Delete", click: deleteHandler },
                                            //   ]}
                                            onlyDate={{
                                                createdAt: "dateTime",

                                            }}
                                            dontShowSort={["status", "cancelled"]}
                                            renderAs={{
                                                status: (data, id) =>
                                                    data === "PAID" ? (
                                                        <span className="label label-lg label-light-success label-inline">
                                                            PAID
                                                        </span>
                                                    ) : (
                                                        <span className="label label-lg label-light-danger label-inline">
                                                            FAILED
                                                        </span>
                                                    ),
                                            }}
                                        />

                                        {perPage !== 0 && (
                                            <Pagination
                                                page={page}
                                                totalDocuments={totalDocuments}
                                                getNewData={fetchMoreData}
                                                perPage={perPage}
                                                defaultPerPage={records_per_page}
                                                perPageChangeHandler={perPageChangeHandler}
                                                currentDocLength={transactions.length}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewAll;
